// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root___kFTI","empty":"ModalGraph_empty__QpX9K"};